export const ChannelType = {
  LV_EVENT: "LV_EVENT",
};